import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {CoreConfigService} from '../../../@core/services/config.service';
import {environment} from '../../../environments/environment';

export const languageHttpInterceptor: HttpInterceptorFn = (request, next) => {
  const coreConfigService = inject(CoreConfigService);

    request = request.clone({
        setHeaders: {
            'Accept-Language': coreConfigService.localConfig?.app?.appLanguage || environment.locale.defaultLanguage,
        },
    });
    return next(request);

}